import type { ReactNode } from 'react';

interface EmptyStateProps {
  message: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ message, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`bg-navy-900 border border-navy-700 rounded-xl p-12 text-center ${className}`}>
      <p className="text-slate-400">{message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
